import { Component, OnInit, Input } from '@angular/core';
import { BookingBreadcrumbsService } from '../../services/booking-breadcrumbs.service';
import { IBreadcrumbsService } from '../../../general/interfaces/breadcrumbs-service.interface';

@Component({
  selector: 'app-booking-page',
  templateUrl: './booking.page.html',
  styleUrls: ['./booking.page.css']
})
export class BookingPageComponent implements OnInit {

  constructor(
    private bookingBreadcrumbsService: BookingBreadcrumbsService,
  ) {
  }

  ngOnInit() {
  }

  get hasActiveBreadcrumbs() {
    return this.bookingBreadcrumbsService.hasActiveBreadcrumbs;
  }

  get breadcrumbsService(): IBreadcrumbsService {
    return this.bookingBreadcrumbsService;
  }
}
